/**
 * Campus Framework API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@bitapp.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum PdfResult {
    Success = 'success',
    InvalidType = 'invalid_type',
    ConversionError = 'conversion_error',
    DecodeError = 'decode_error',
    SystemError = 'system_error',
    CodeNotFound = 'code_not_found',
    CertificationNotFound = 'certification_not_found',
    DayNotFound = 'day_not_found'
};

